import { defineComponent, h } from 'vue';
import { BaseActivity } from '@/entities/activity/model';
import { createdAt } from '@/ui/components/activityLogs/common/CreatedAt';
import { t } from '@/ui/i18n/i18n';
import { boldifyString } from '@/ui/components/activityLogs/helpers';
import { InspectionActivitiesProps } from '@/ui/components/activityLogs/types';

type StartedProps = InspectionActivitiesProps<BaseActivity>;

export const Started = defineComponent<StartedProps>({
  name: 'Started',
  props: ['resourceName', 'log'],
  setup(props) {
    return function render() {
      return h('div', { class: 'activity-logs__log' }, [
        createdAt({ props: { log: props.log } }),
        h('span', {
          domProps: {
            innerHTML: t('activity-logs.inspection-started', {
              username: boldifyString(props.log.user?.name ?? ''),
            }),
          },
        }),
      ]);
    };
  },
});
